export const ACTIVE_ORDERS_CONSTANTS = {
  CURRENT_ORDERS: 'currentOrders',
  ORDER_HASH: 'orderHash',
  ORDER_GETTING_READY: 'orderGettingReady',
  YOUR_ORDER_IS_SCHEDULED: 'yourOrderIsScheduled',
  PICKUP_DETAILS: 'pickupDetails',
  SCHEDULED: 'scheduled',
  TRACK_DELIVERY: 'trackDelivery',
  TRACK_ORDER: 'trackOrder',
  SCHEDULED_TIME: 'scheduledTime',
  READY_FOR_PICKUP: 'readyForPickup',
};
